module.exports = __webpack_public_path__ + "img/发布单笔询价icon@2x.d9204ffb.png";